import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";

export default function TestimonialGrid() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {TESTIMONIALS.map((t, i) => (
        <div key={i} className="bg-white border border-slate-200 rounded-2xl p-6 hover:shadow-md transition-shadow" data-testid={`testimonial-card-${i}`}>
          <div className="flex items-center gap-1 mb-3 text-amber-500">
            {Array.from({ length: t.rating }).map((_, k) => <Star key={k} className="w-4 h-4 fill-amber-500" />)}
          </div>
          <p className="text-sm text-slate-700 leading-relaxed mb-6">“{t.text}”</p>
          <div className="flex items-center gap-3">
            <img src={t.avatar} alt={`${t.name}, ${t.role}`} width="40" height="40" className="w-10 h-10 rounded-full object-cover" loading="lazy" decoding="async" />
            <div>
              <div className="text-sm font-semibold text-slate-900">{t.name}</div>
              <div className="text-xs text-slate-500">{t.role}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
